import Vue from 'vue'
import {postBlob} from "@/plugins/axios";

//品牌检索
export function brandSearch(data) {
    return Vue.axios({
        url: '/api/brand_record/search',
        method: 'post',
        data: {...data}
    })
}
// 获取品牌合作记录
export function getBrandRecordList(data) {
    return Vue.axios({
        url: '/api/brand_record/get_list',
        method: 'post',
        data: {...data}
    })
}
// 获取品牌信息
export function getBrandRecord(data) {
    return Vue.axios({
        url: '/api/brand_record/query',
        method: 'post',
        data: {...data}
    })
}

// 获取品牌对应客户信息
export function brandCustomerRecords(data) {
    return Vue.axios({
        url: '/api/brand_record/customer_records',
        method: 'post',
        data: {...data}
    })
}

// 获取新客销售额
export function getCustomerSaleVolume(data) {
    return Vue.axios({
        url: '/api/customer_sale_volume/query',
        method: 'post',
        data: {...data}
    })
}

//客户公共池-客户记录-查询
export function getCustomerRecordList(data) {
    return Vue.axios({
        url: '/api/customer_record/query',
        method: 'post',
        data: {...data}
    })
}

//客户公共池-客户记录-统计
export function getCustomerRecordStatistics(data) {
    return Vue.axios({
        url: '/api/customer_record/statistics',
        method: 'post',
        data: {...data}
    })
}

//客户公共池-客户记录-统计(跟进任务)
export function getCustomerRecordStatisticsTask(data) {
    return Vue.axios({
        url: '/api/customer_record/statistics_task',
        method: 'post',
        data: {...data}
    })
}

//客户公共池-客户记录-添加
export function customerRecordStore(data) {
    return Vue.axios({
        url: '/api/customer_record/store',
        method: 'post',
        data: {...data}
    })
}

//客户公共池-客户记录-批量添加
/**
 *
 * @param rows
 * @returns {*}
 */
export function customerRecordBatchStore(rows) {

    return Vue.axios({
        url: '/api/customer_record/batchstore',
        method: 'post',
        data: {'_rows':rows}
    })
}

//客户公共池-客户记录-详情
export function getCustomerRecordInfo(data) {
    return Vue.axios({
        url: '/api/customer_record/info',
        method: 'post',
        data: {...data}
    })
}

//客户公共池-客户记录-删除
export function customerRecordDel(data) {
    return Vue.axios({
        url: '/api/customer_record/delete',
        method: 'post',
        data: {...data}
    })
}

//客户公共池-客户记录-重置分配（返回公共池）
export function getCustomerRecordReset(data) {
    return Vue.axios({
        url: '/api/customer_record/resetState',
        method: 'post',
        data: {...data}
    })
}

//客户公共池-客户记录-分配销售
export function customerRecordSetSale(data) {
    return Vue.axios({
        url: '/api/customer_record/setSale',
        method: 'post',
        data: {...data}
    })
}

//客户公共池-客户记录-可选销售
export function getCustomerRecordSaleOptions(data) {
    return Vue.axios({
        url: '/api/customer_record/saleOptions',
        method: 'post',
        data: {...data}
    })
}

//客户公共池-客户记录-跟进记录
export function getCustomerFollowRecordList(data) {
    return Vue.axios({
        url: '/api/customer_follow_record/query',
        method: 'post',
        data: {...data}
    })
}

//客户公共池-客户查询接口
/**
 *
 * @param data
 * @returns {*}
 */
export function queryCustomerList(data = {name: null, lastTradeMonths: null}) {
    return Vue.axios({
        url: '/api/customer_record/queryCustomerList',
        method: 'post',
        data: {...data}
    })
}

//客户公共池-客户记录-跟进记录-添加
export function customerFollowRecordStore(data) {
    return Vue.axios({
        url: '/api/customer_follow_record/store',
        method: 'post',
        data: {...data}
    })
}

//客户公共池-客户记录-跟进记录-删除
export function customerFollowRecordDelete(data) {
    return Vue.axios({
        url: '/api/customer_follow_record/delete',
        method: 'post',
        data: {...data}
    })
}
//导出年度新客开拓检测表皮
export function downloadCustomerExport(data) {
    return postBlob('/api/customer_sale_volume/export', data)
}
